/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ProductPositionFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateProductPositionInput = {
  configurationKey?: string | null
  dimensioning?: ExternalDimensioningResultInput | null
  displayPosition?: string | null
  id: string
  isAlternative?: boolean | null
  label?: string | null
  parent?: JsonapiRelationshipData | null
  position?: number | null
  price?: number | null
  priceGroup?: string | null
  quantity: number
  references?: Array<ProductPositionInstallationReferenceInput> | null
  remark?: string | null
  variantKey: string
}

export type ExternalDimensioningResultInput = {
  dllVersion?: string | null
  environmentalVars?: any
  language?: string | null
  supplementaryText?: Array<ExternalDimensioningSupplementaryTextInput> | null
  technicalData?: Array<ExternalDimensioningTechnicalDataInput> | null
  technicalInput?: Array<ExternalDimensioningTechnicalInputInput> | null
  transactionId: string
  transferData?: ExternalDimensioningTransferDataInput | null
  variantKeyData?: any
}

export type ExternalDimensioningSupplementaryTextInput = {
  text: string
}

export type ExternalDimensioningTechnicalDataInput = {
  content?: any
  dllVersion?: string | null
  header?: Array<string> | null
  summary?: string | null
  type?: string | null
}

export type ExternalDimensioningTechnicalInputInput = {
  label?: string | null
  name: string
  unit?: string | null
  userSelected: boolean
  value?: any
}

export type ExternalDimensioningTransferDataInput = {
  origin?: string | null
}

export type JsonapiRelationshipData = {
  id: string
  type: string
}

export type ProductPositionInstallationReferenceInput = {
  id: string
  permalink: string
  position: number
  title?: string | null
}

export type UpdateProductPositionInput = {
  configurationKey?: string | null
  dimensioning?: ExternalDimensioningResultInput | null
  displayPosition?: string | null
  id: string
  isAlternative?: boolean | null
  label?: string | null
  parent?: JsonapiRelationshipData | null
  position?: number | null
  price?: number | null
  priceGroup?: string | null
  quantity?: number | null
  references?: Array<ProductPositionInstallationReferenceInput> | null
  remark?: string | null
  variantKey?: string | null
}

export type CreateProductPositionMutationVariables = Exact<{
  parentID: string
  parentType: string
  input: Types.CreateProductPositionInput
}>

export type CreateProductPositionMutation = {
  __typename: "Mutation"
  productPosition: {
    __typename: "ProductPosition"
    id: string
    label?: string | null
    variantKey: string
    configurationKey?: string | null
    remark?: string | null
    quantity: number
    position: number
    displayPosition?: string | null
    isAlternative?: boolean | null
    price?: number | null
    priceGroup?: string | null
    hasClarificationRequest?: boolean | null
    references?: Array<{
      __typename: "ProductPositionInstallationReference"
      id: string
      title?: string | null
      permalink: string
      position: number
    }> | null
    addons?: Array<{
      __typename: "ProductPositionAddon"
      id: string
      variantKey: string
      parentProductType: string
    }> | null
    dimensioning?: {
      __typename: "ExternalDimensioningResult"
      transactionId: string
      environmentalVars?: Array<any> | null
      variantKeyData?: any
      dllVersion?: string | null
      language?: string | null
      technicalData?: Array<
        | {
            __typename: "ExternalDimensioningTechnicalDataDllVersion"
            dllVersion: string
          }
        | {
            __typename: "ExternalDimensioningTechnicalDataTable"
            header?: Array<string> | null
            content?: any
            summary?: string | null
            type?: string | null
          }
      > | null
      technicalInput?: Array<{
        __typename: "ExternalDimensioningTechnicalInput"
        name: string
        label?: string | null
        unit?: string | null
        value?: any
        userSelected: boolean
      }> | null
      supplementaryText?: Array<{
        __typename: "ExternalDimensioningSupplementaryText"
        text: string
      }> | null
      transferData?: {
        __typename: "ExternalDimensioningTransferData"
        origin?: string | null
      } | null
    } | null
  }
}

export type BatchCreateProductPositionsMutationVariables = Exact<{
  projectID: string
  input:
    | Array<Types.CreateProductPositionInput>
    | Types.CreateProductPositionInput
}>

export type BatchCreateProductPositionsMutation = {
  __typename: "Mutation"
  productPositions: Array<{
    __typename: "ProductPosition"
    id: string
    label?: string | null
    variantKey: string
    configurationKey?: string | null
    remark?: string | null
    quantity: number
    position: number
    displayPosition?: string | null
    isAlternative?: boolean | null
    price?: number | null
    priceGroup?: string | null
    hasClarificationRequest?: boolean | null
    references?: Array<{
      __typename: "ProductPositionInstallationReference"
      id: string
      title?: string | null
      permalink: string
      position: number
    }> | null
    addons?: Array<{
      __typename: "ProductPositionAddon"
      id: string
      variantKey: string
      parentProductType: string
    }> | null
    dimensioning?: {
      __typename: "ExternalDimensioningResult"
      transactionId: string
      environmentalVars?: Array<any> | null
      variantKeyData?: any
      dllVersion?: string | null
      language?: string | null
      technicalData?: Array<
        | {
            __typename: "ExternalDimensioningTechnicalDataDllVersion"
            dllVersion: string
          }
        | {
            __typename: "ExternalDimensioningTechnicalDataTable"
            header?: Array<string> | null
            content?: any
            summary?: string | null
            type?: string | null
          }
      > | null
      technicalInput?: Array<{
        __typename: "ExternalDimensioningTechnicalInput"
        name: string
        label?: string | null
        unit?: string | null
        value?: any
        userSelected: boolean
      }> | null
      supplementaryText?: Array<{
        __typename: "ExternalDimensioningSupplementaryText"
        text: string
      }> | null
      transferData?: {
        __typename: "ExternalDimensioningTransferData"
        origin?: string | null
      } | null
    } | null
  }>
}

export type UpdateProductPositionMutationVariables = Exact<{
  id: string
  input: Types.UpdateProductPositionInput
}>

export type UpdateProductPositionMutation = {
  __typename: "Mutation"
  productPosition: {
    __typename: "ProductPosition"
    id: string
    label?: string | null
    variantKey: string
    configurationKey?: string | null
    remark?: string | null
    quantity: number
    position: number
    displayPosition?: string | null
    isAlternative?: boolean | null
    price?: number | null
    priceGroup?: string | null
    hasClarificationRequest?: boolean | null
    references?: Array<{
      __typename: "ProductPositionInstallationReference"
      id: string
      title?: string | null
      permalink: string
      position: number
    }> | null
    addons?: Array<{
      __typename: "ProductPositionAddon"
      id: string
      variantKey: string
      parentProductType: string
    }> | null
    dimensioning?: {
      __typename: "ExternalDimensioningResult"
      transactionId: string
      environmentalVars?: Array<any> | null
      variantKeyData?: any
      dllVersion?: string | null
      language?: string | null
      technicalData?: Array<
        | {
            __typename: "ExternalDimensioningTechnicalDataDllVersion"
            dllVersion: string
          }
        | {
            __typename: "ExternalDimensioningTechnicalDataTable"
            header?: Array<string> | null
            content?: any
            summary?: string | null
            type?: string | null
          }
      > | null
      technicalInput?: Array<{
        __typename: "ExternalDimensioningTechnicalInput"
        name: string
        label?: string | null
        unit?: string | null
        value?: any
        userSelected: boolean
      }> | null
      supplementaryText?: Array<{
        __typename: "ExternalDimensioningSupplementaryText"
        text: string
      }> | null
      transferData?: {
        __typename: "ExternalDimensioningTransferData"
        origin?: string | null
      } | null
    } | null
  }
}

export type DeleteProductPositionMutationVariables = Exact<{
  id: string
}>

export type DeleteProductPositionMutation = {
  __typename: "Mutation"
  productPosition: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateProductPositionDocument = gql`
  mutation CreateProductPosition(
    $parentID: ID!
    $parentType: String!
    $input: CreateProductPositionInput!
  ) {
    productPosition: createProductPosition(
      parentID: $parentID
      parentType: $parentType
      input: $input
    )
      @rest(
        type: "ProductPosition"
        endpoint: "productPosition"
        method: "POST"
        path: "/project-list/{args.parentType}/{args.parentID}/children"
        bodySerializer: "productPosition"
      ) {
      ...ProductPosition
    }
  }
  ${ProductPositionFragmentDoc}
`
export type CreateProductPositionMutationFn = Apollo.MutationFunction<
  CreateProductPositionMutation,
  CreateProductPositionMutationVariables
>

/**
 * __useCreateProductPositionMutation__
 *
 * To run a mutation, you first call `useCreateProductPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductPositionMutation, { data, loading, error }] = useCreateProductPositionMutation({
 *   variables: {
 *      parentID: // value for 'parentID'
 *      parentType: // value for 'parentType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProductPositionMutation,
    CreateProductPositionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateProductPositionMutation,
    CreateProductPositionMutationVariables
  >(CreateProductPositionDocument, options)
}
export type CreateProductPositionMutationHookResult = ReturnType<
  typeof useCreateProductPositionMutation
>
export type CreateProductPositionMutationResult =
  Apollo.MutationResult<CreateProductPositionMutation>
export type CreateProductPositionMutationOptions = Apollo.BaseMutationOptions<
  CreateProductPositionMutation,
  CreateProductPositionMutationVariables
>
export const BatchCreateProductPositionsDocument = gql`
  mutation BatchCreateProductPositions(
    $projectID: ID!
    $input: [CreateProductPositionInput!]!
  ) {
    productPositions: batchCreateProductPositions(
      projectID: $projectID
      input: $input
    )
      @rest(
        type: "ProductPosition"
        endpoint: "productPosition"
        method: "POST"
        path: "/project-list/projects/{args.projectID}/children"
        bodySerializer: "productPosition"
      ) {
      ...ProductPosition
    }
  }
  ${ProductPositionFragmentDoc}
`
export type BatchCreateProductPositionsMutationFn = Apollo.MutationFunction<
  BatchCreateProductPositionsMutation,
  BatchCreateProductPositionsMutationVariables
>

/**
 * __useBatchCreateProductPositionsMutation__
 *
 * To run a mutation, you first call `useBatchCreateProductPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateProductPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateProductPositionsMutation, { data, loading, error }] = useBatchCreateProductPositionsMutation({
 *   variables: {
 *      projectID: // value for 'projectID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateProductPositionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BatchCreateProductPositionsMutation,
    BatchCreateProductPositionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BatchCreateProductPositionsMutation,
    BatchCreateProductPositionsMutationVariables
  >(BatchCreateProductPositionsDocument, options)
}
export type BatchCreateProductPositionsMutationHookResult = ReturnType<
  typeof useBatchCreateProductPositionsMutation
>
export type BatchCreateProductPositionsMutationResult =
  Apollo.MutationResult<BatchCreateProductPositionsMutation>
export type BatchCreateProductPositionsMutationOptions =
  Apollo.BaseMutationOptions<
    BatchCreateProductPositionsMutation,
    BatchCreateProductPositionsMutationVariables
  >
export const UpdateProductPositionDocument = gql`
  mutation UpdateProductPosition(
    $id: ID!
    $input: UpdateProductPositionInput!
  ) {
    productPosition: updateProductPosition(id: $id, input: $input)
      @rest(
        type: "ProductPosition"
        method: "PUT"
        endpoint: "productPosition"
        path: "/project-list/project-positions/{args.id}"
        bodySerializer: "productPosition"
      ) {
      ...ProductPosition
    }
  }
  ${ProductPositionFragmentDoc}
`
export type UpdateProductPositionMutationFn = Apollo.MutationFunction<
  UpdateProductPositionMutation,
  UpdateProductPositionMutationVariables
>

/**
 * __useUpdateProductPositionMutation__
 *
 * To run a mutation, you first call `useUpdateProductPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductPositionMutation, { data, loading, error }] = useUpdateProductPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProductPositionMutation,
    UpdateProductPositionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateProductPositionMutation,
    UpdateProductPositionMutationVariables
  >(UpdateProductPositionDocument, options)
}
export type UpdateProductPositionMutationHookResult = ReturnType<
  typeof useUpdateProductPositionMutation
>
export type UpdateProductPositionMutationResult =
  Apollo.MutationResult<UpdateProductPositionMutation>
export type UpdateProductPositionMutationOptions = Apollo.BaseMutationOptions<
  UpdateProductPositionMutation,
  UpdateProductPositionMutationVariables
>
export const DeleteProductPositionDocument = gql`
  mutation DeleteProductPosition($id: ID!) {
    productPosition: deleteProductPosition(id: $id)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/project-positions/{args.id}"
      ) {
      success
    }
  }
`
export type DeleteProductPositionMutationFn = Apollo.MutationFunction<
  DeleteProductPositionMutation,
  DeleteProductPositionMutationVariables
>

/**
 * __useDeleteProductPositionMutation__
 *
 * To run a mutation, you first call `useDeleteProductPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductPositionMutation, { data, loading, error }] = useDeleteProductPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProductPositionMutation,
    DeleteProductPositionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteProductPositionMutation,
    DeleteProductPositionMutationVariables
  >(DeleteProductPositionDocument, options)
}
export type DeleteProductPositionMutationHookResult = ReturnType<
  typeof useDeleteProductPositionMutation
>
export type DeleteProductPositionMutationResult =
  Apollo.MutationResult<DeleteProductPositionMutation>
export type DeleteProductPositionMutationOptions = Apollo.BaseMutationOptions<
  DeleteProductPositionMutation,
  DeleteProductPositionMutationVariables
>
